// shorthand for querySelector
export const $ = (
  selector: string,
  context: HTMLElement | HTMLDocument = document
): HTMLElement | null => context.querySelector(selector);

// shorthand for querySelectorAll
export const $$ = (
  selector: string,
  context: HTMLElement | HTMLDocument = document
): NodeListOf<HTMLElement> | null => context.querySelectorAll(selector);

// shorthand for classList.toggle
export const toggleClass = (
  target: HTMLElement | Element | null,
  className: string,
  toggler: boolean
): void => {
  if (target) {
    target.classList.toggle(className, toggler);
  }
};

// short hand for addEventListener
export const on = (
  target: HTMLElement | HTMLDocument | null,
  type: string,
  listener: EventListener,
  useCapture: boolean = false
): void => {
  if (target) {
    target.addEventListener(type, listener, useCapture);
  }
};

// short hand for removeEventListener
export const off = (
  target: HTMLElement | HTMLDocument | null,
  type: string,
  listener: EventListener
): void => {
  if (target) {
    target.removeEventListener(type, listener);
  }
};

// a function that adds an event and then removes that event when the
// event has been triggered
export const onOff = (
  target: HTMLElement | Document,
  type: string,
  listener: EventListener,
  useCapture: boolean = false
) => {
  const eventListener = (event: Event) => {
    listener(event);
    off(target, type, eventListener);
  };
  on(target, type, eventListener, useCapture);
};

// check if the event happened outside of a target element
export const isClickOutside = (target: HTMLElement, event: Event) => {
  if (event.target) {
    let node: HTMLElement | null = event.target as HTMLElement;

    do {
      // tslint:disable triple-equals
      if (node == target) {
        return false;
      }
      // tslint:enable tripe-equals
      node = node.parentNode as HTMLElement;
    } while (node);

    return true;
  }

  return true;
};

// Set attributes on HTML elements, as an example `aria` rules.
export const setAttr = (
  target: HTMLElement,
  attribute: string,
  value: string = ""
): void => {
  target.setAttribute(attribute, value);
};

// Remove attributes from HTML elements
export const removeAttr = (target: HTMLElement, attribute: string): void => {
  target.removeAttribute(attribute);
};

// Get custom property values set on `:root {}`
export const getCustomProperty = (name: string): string =>
  window.getComputedStyle(document.documentElement).getPropertyValue(name);

// Helper function to set cookie.
export const setCookie = (
  name: string,
  value: string,
  days: number = 7,
  path: string = "/"
) =>
  (document.cookie = `${name}=${encodeURIComponent(value)}; expires=${new Date(
    Date.now() + days * 864e5
  ).toUTCString()}; path=${path}`);

export const setSessionCookie = (name: string, value: string, path: string = "/") =>
  (document.cookie = `${name}=${encodeURIComponent(value)}; path=${path}`);

// Helper function to read cookies
export const getCookie = (name: string) =>
  document.cookie.split("; ").reduce((cookieValue, cookie) => {
    const [key, value] = cookie.split("=");
    return key === name ? decodeURIComponent(value) : cookieValue;
  }, "");

export const toggleDetailsOpen = (
  detailsElements: NodeListOf<HTMLElement> | null,
  isTablet: boolean
) => {
  if (detailsElements) {
    detailsElements.forEach((detailsElement: HTMLDetailsElement) => {
      if (detailsElement) {
        if (isTablet) {
          setAttr(detailsElement, "open");
        } else {
          removeAttr(detailsElement, "open");
        }
      }
    });
  }
};
